import { getVideos } from '../api/admin-settings'
import useApi from '../hooks/useApi'
import Media from './Media'
import Logo from './Logo'
import Image from '../assets/home-banner.webp'
import { memo } from 'react'

const HomeBanner = () => {
  const [ video ] = useApi(() => getVideos('INICIO'), '')

  return (
    <div className='HomeBanner'>
      <div className="HomeBanner__Cover"></div>
      {/* <Media
        type="video"
        className="HomeBanner__Image"
        src={video}
        alt="Vida Cowork"
        autoPlay
        loop
        muted
      /> */}
      <img
        className="HomeBanner__Image"
        src={Image}
        alt="Vida Cowork"
        title="Vida Cowork"
        fetchPriority='high'
      />
      <div className="HomeBanner__Title-Container">
        <Logo className='HomeBanner__Logo'/>
        <h1 className="title">
          Creamos un entorno donde la presencia, el enfoque y el bienestar se
          combinan para hacer que tu experiencia de trabajo sea única.
        </h1>
      </div>
    </div>
  )
}

export default memo(HomeBanner)